// extracted by mini-css-extract-plugin
module.exports = {"toogleBtn":"src-screens-ActDetails-components-ActDetailsTable-module__toogleBtn--1wdkb"};